import axios from "axios";

const baseUrl = process.env.REACT_APP_WOO_COMMERCE_BASE_URL;
const consumerKey = process.env.REACT_APP_WOO_COMMERCE_CONSUMER_KEY;
const consumerSecret = process.env.REACT_APP_WOO_COMMERCE_CONSUMER_SECRET;
console.log("All envs:", process.env);

console.log("WooCommerce Base URL:", baseUrl);
console.log("WooCommerce Consumer Key:", consumerKey);
console.log("WooCommerce Consumer Secret:", consumerSecret);
const authString = btoa(`${consumerKey}:${consumerSecret}`);

const apiClient = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization: `Basic ${authString}`,
    "Content-Type": "application/json",
  },
});

export const getCoupons = () => {
  return apiClient.get<any[]>("/wp-json/wc/v3/coupons");
};

export const getCouponsDetails = (couponId: number) => {
  return apiClient.get<any[]>("/wp-json/wc/v3/coupons/" + couponId);
};

export const getVendors = (page: number, per_page: number, search: string) => {
  return apiClient.get<any[]>('/wp-json/wcfmmp/v1/store-vendors', {
    params: { page, per_page, search },
  });
};

export const getVendorsTotal = async (): Promise<number> => {
  const response = await apiClient.get<any[]>(
    "/wp-json/wcfmmp/v1/store-vendors?page=1&per_page=100"
  );

  const total = response.data.length;
  console.log("Total vendors:", total);

  return total;
};


export const getProducts = (params?: {
  page?: number;
  per_page?: number;
  search?: string;
  vendor_id?: number;
}) => {
  return apiClient.get<any[]>("/wp-json/wc/v3/products", { params });
};


export const getProductDetails = (productId: number) => {
  return apiClient.get<any>(`/wp-json/wc/v3/products/${productId}`);
};


export const getProductReview = (params: any) => {
  return apiClient.get<any>(`/wp-json/wc/v3/products/reviews`, { params });
};

export const getProductVariations = (productId: number) => {
  return apiClient.get<any>(`/wp-json/wc/v3/products/${productId}/variations`);
};


export const getProductCategories = () => {
  return apiClient.get<any[]>("/wp-json/wc/v3/products/categories");
}

export const getOrders = (params?: { page?: number; per_page?: number; status?: string; search?: string }) => {
  return apiClient.get<any[]>("/wp-json/wc/v3/orders", { params });
};

export const getOrderDetails = (orderId: number) => {
  return apiClient.get<any>(`/wp-json/wc/v3/orders/${orderId}`);
};

export const getCompletedOrdersWithinDateRange = (after: string, before: string, params?: { page?: number; per_page?: number }) => {
  return apiClient.get<any[]>("/wp-json/wc/v3/orders", {
    params: {
      status: "completed",
      after,
      before,
      ...params,
    },
  });
};
export const getOrderTotals = () => {
  return apiClient.get<any>(`/wp-json/wc/v3/reports/orders/totals`);
};

export const getProductTotals = () => {
  return apiClient.get<any>(`/wp-json/wc/v3/reports/products/totals`);
};
/**
 * Create a new coupon.
 * @param couponData - Object with coupon details as per WooCommerce API
 */
export const createCoupon = (couponData: Record<string, any>) => {
  return apiClient.post("/wp-json/wc/v3/coupons", couponData);
};

/**
 * Delete a coupon by ID.
 * @param couponId - The ID of the coupon to delete.
 * @param force - Whether to permanently delete the coupon (default: false, moves to trash).
 */
export const deleteCoupon = (couponId: number, force = false) => {
  return apiClient.delete(`/wp-json/wc/v3/coupons/${couponId}`, {
    params: {
      force,
    },
  });
};

// Base update function for reviews
const updateProductReview = (reviewId: number, data: Record<string, any>) =>
  apiClient.put(`/wp-json/wc/v3/products/reviews/${reviewId}`, data);

export const getProductReviewsByStatus = async (status: string) => {
  if (status === "flagged") {
    return apiClient.get("/wp-json/wc/v3/products/reviews?per_page=100");
  } else {
    return apiClient.get(`/wp-json/wc/v3/products/reviews?status=${status}&per_page=100`);
  }
};


// Shorthand for pending reviews
export const getPendingProductReviews = () =>
  getProductReviewsByStatus("hold");

export const approveProductReview = (reviewId: number) =>
  updateProductReview(reviewId, { status: "approved" });

export const rejectProductReview = (reviewId: number) =>
  updateProductReview(reviewId, { status: "spam" });

// Flag with custom metadata (works only if WooCommerce supports reading this back)
export const flagProductReview = (reviewId: number) =>
  updateProductReview(reviewId, {
    meta_data: [{ key: "is_flagged", value: true }],
  });


export const getPendingVendors = async () => {

  const wooToken = sessionStorage.getItem("wooToken");

  console.log('$$$$$$$$$$$$$$$$$$$', wooToken)
  if (!wooToken) {
    throw new Error("WooCommerce token missing. Please log in again.");
  }

  const response = await axios.get(`${baseUrl}/wp-json/wcfm/v1/vendors/pending`, {
    headers: {
      Authorization: `Bearer ${wooToken}`,
    },
  });

  return response;
};

export const updateVendorApproval = async (
  vendorId: number,
  status: "approve" | "reject",
  reason?: string
) => {
  const wooToken = sessionStorage.getItem("wooToken");

  if (!wooToken) throw new Error("WooCommerce token missing. Please log in again.");

  const response = await axios.post(
    `${baseUrl}/wp-json/wcfm/v1/vendor-approval`,
    { vendor_id: vendorId, status, reason },
    { headers: { Authorization: `Bearer ${wooToken}` } }
  );

  return response;
};
